var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgroecoTransition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.646,
    height: 30.666,
    viewBox: "0 0 28.646 30.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1070",
    "data-name": "Groupe 1070",
    transform: "translate(5962.385 -767.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10740",
    "data-name": "Trac\\xE9 10740",
    d: "M-5950.807,789.943c1.5-5.2-2.133-8.613-11.1-10.175a.41.41,0,0,0-.462.516c2.524,8.743,6.313,11.985,11.318,9.93A.424.424,0,0,0-5950.807,789.943Z",
    transform: "translate(0 -5.162)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10741",
    "data-name": "Trac\\xE9 10741",
    d: "M-5935.806,782.5c-2.925-6.3,1.009-11.343,12.071-15.089a.527.527,0,0,1,.689.564c-1.481,11.584-5.646,16.441-12.4,14.82A.545.545,0,0,1-5935.806,782.5Z",
    transform: "translate(-10.698 0)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10742",
    "data-name": "Trac\\xE9 10742",
    d: "M-5939.5,803.379a.437.437,0,0,1-.429-.351c-.031-.153-2.936-15.4,10.058-22.814a.437.437,0,0,1,.6.163.436.436,0,0,1-.164.6c-12.436,7.092-9.661,21.735-9.633,21.882a.437.437,0,0,1-.342.515A.443.443,0,0,1-5939.5,803.379Z",
    transform: "translate(-9.241 -5.327)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10743",
    "data-name": "Trac\\xE9 10743",
    d: "M-5944.229,802.386l-.037,0a.438.438,0,0,1-.4-.472c.543-6.487-5.9-11.81-5.96-11.863a.438.438,0,0,1-.063-.615.438.438,0,0,1,.615-.063c.281.228,6.862,5.661,6.28,12.614A.436.436,0,0,1-5944.229,802.386Z",
    transform: "translate(-4.838 -9.13)",
    fill: "#f6c459"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroecoTransition);
export default __webpack_public_path__ + "static/media/agroeco_transition.4057385749b18b306c4a85b851b1bec1.svg";
export { ForwardRef as ReactComponent };